import tinycolor from 'tinycolor2';

/** Border shown on light swatches and gradient previews so they remain visible on white UI surfaces. */
export const SWATCH_BORDER_CLASS =
  'border border-[var(--modus-wc-color-base-200,#e0e1e9)]';

const LIGHT_SWATCH_COLOR_ALPHA_THRESHOLD = 0.2;
const LIGHT_SWATCH_COLOR_HSL_LIGHTNESS_THRESHOLD = 0.93;

export function isLightSwatchColor(color: string): boolean {
  const c = tinycolor(color);
  if (!c.isValid()) {
    return false;
  }

  const alpha = c.getAlpha();
  if (alpha < LIGHT_SWATCH_COLOR_ALPHA_THRESHOLD) {
    return true;
  }

  const hsl = c.toHsl();
  if (hsl.l > LIGHT_SWATCH_COLOR_HSL_LIGHTNESS_THRESHOLD) {
    return true;
  }

  return false;
}

export function stopsContainLightColor(
  stops: readonly { readonly color: string }[]
): boolean {
  return stops.some((stop) => isLightSwatchColor(stop.color));
}
